import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Overview20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_887)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.25 7.5C10.25 6.80964 10.8096 6.25 11.5 6.25H14.5C15.1904 6.25 15.75 6.80964 15.75 7.5V10.5C15.75 11.1904 15.1904 11.75 14.5 11.75H11.5C10.8096 11.75 10.25 11.1904 10.25 10.5V7.5ZM11.75 10.25H14.25V7.75H11.75V10.25Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11 0.75C6.44365 0.75 2.75 4.44365 2.75 9C2.75 11.0081 3.46748 12.8487 4.66007 14.2793L0.969727 17.9697L2.03039 19.0303L5.72074 15.34C7.15135 16.5325 8.99189 17.25 11 17.25C15.5563 17.25 19.25 13.5563 19.25 9C19.25 4.44365 15.5563 0.75 11 0.75ZM4.83375 6.25C5.88661 3.89277 8.25146 2.25 11 2.25C14.7279 2.25 17.75 5.27208 17.75 9C17.75 12.7279 14.7279 15.75 11 15.75C8.25146 15.75 5.88661 14.1072 4.83375 11.75H7C7.69036 11.75 8.25 11.1904 8.25 10.5V7.5C8.25 6.80964 7.69036 6.25 7 6.25H4.83375ZM4.36551 7.75C4.28967 8.15508 4.25 8.57291 4.25 9C4.25 9.42709 4.28967 9.84492 4.36551 10.25H6.75V7.75H4.36551Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_887'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Overview20.displayName = 'Overview20';
export default Overview20;
